import { AHTeamIconCircle, AHText, Box, TouchableBox } from "arkh";
import React, { useEffect, useRef } from "react";
import { Platform, StyleSheet, View } from "react-native";
import { graphql, useFragment } from "react-relay";
import { useWidgetLayoutContentSize } from "../useWidgetLayoutContentSize";
import { WidgetIssueSummaryTeamItemUnresolvedCount_team$key } from "./__generated__/WidgetIssueSummaryTeamItemUnresolvedCount_team.graphql";
import { WidgetIssueSummaryTeamItem_team$key } from "./__generated__/WidgetIssueSummaryTeamItem_team.graphql";

export const WidgetIssueSummaryTeamItem = React.memo(
  WidgetIssueSummaryTeamItemC
);
function WidgetIssueSummaryTeamItemC(props: {
  team: WidgetIssueSummaryTeamItem_team$key;
  onPress: (teamId: string, teamName: string, teamColor: string | null) => void;
}) {
  const team = useFragment(
    graphql`
      fragment WidgetIssueSummaryTeamItem_team on Team {
        id
        name
        icon
        color

        ...WidgetIssueSummaryTeamItemUnresolvedCount_team
      }
    `,
    props.team
  );
  const height =
    useWidgetLayoutContentSize().unit / 3 - StyleSheet.hairlineWidth;

  return (
    <TouchableBox
      onPress={() => props.onPress(team.id, team.name, team.color)}
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height,
      }}
      spaceHorizontal="medium"
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHTeamIconCircle color={team.color} type={team.icon} size="medium" />
        <AHText spaceLeft="medium" type="title-small">
          {team.name}
        </AHText>
      </Box>
      <UnresolvedCount team={team} />
    </TouchableBox>
  );
}

function UnresolvedCount(props: {
  team: WidgetIssueSummaryTeamItemUnresolvedCount_team$key;
}) {
  const { unresolvedIssueCount } = useFragment(
    graphql`
      fragment WidgetIssueSummaryTeamItemUnresolvedCount_team on Team {
        unresolvedIssueCount
      }
    `,
    props.team
  );

  const isAnimationRunning =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    Platform.OS === "web" ? useIsAnimation(unresolvedIssueCount) : false;

  return (
    <View
      style={
        {
          flexDirection: "row",
          alignItems: "baseline",
          transform: isAnimationRunning ? [{ scale: 1.4 }] : [],
          transition: Platform.OS === "web" ? "transform .5s" : undefined,
        } as any
      }
    >
      <AHText type="title">{unresolvedIssueCount}</AHText>
    </View>
  );
}

function useIsAnimation(unresolvedIssueCount: number) {
  const [isAnimationRunning, setIsAnimationRunning] = React.useState(false);

  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    setIsAnimationRunning(true);
    const to = setTimeout(() => {
      setIsAnimationRunning(false);
    }, 1000);
    return () => {
      clearTimeout(to);
    };
  }, [unresolvedIssueCount]);

  return isAnimationRunning;
}
